 function isUserFromEUQuick() {
  const EU_COUNTRIES = ["AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE"];
  const countryCode = localStorage.getItem('userGeolocation');
  return EU_COUNTRIES.includes(countryCode);
}

var codeExecutedQuick = false;
var originalPricesQuick = {}; // Оригинальные цены для каждого варианта

  const europeanUnionCountriesQuickView = [
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE",
  "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT",
  "RO", "SK", "SI", "ES", "SE"
];

async function isUserFromEUPQuickView() {
  console.log("EUEUEU")
  let countryCode = localStorage.getItem('userGeolocation');

  if (!countryCode) {
    try {
      const response = await fetch("https://ipapi.co/json/");
      const json = await response.json();
      countryCode = json.country_code;
      localStorage.setItem('userGeolocation', countryCode);
    } catch (error) {
      console.error("❌ Не удалось определить страну пользователя:", error);
      return false;
    }
  }

  return europeanUnionCountriesQuickView.includes(countryCode);
}

async function changeUsdToEuroQuickView() {
  const isEU = await isUserFromEUPQuickView();
  if (!isEU) {
    console.log("🌍 Пользователь не из ЕС — цены остаются в USD");
    return;
  }

  document.querySelectorAll(".product-information_quick-view #first-price-quick-view .money, .product-information_quick-view #final-price-quick-view .money, .product-information_quick-view #final-price-quick-view-two .money, .product-information_quick-view #final-price-precents-dekstop-quick-view .money, .product-information_quick-view #final-price-precents-dekstop-quick-view-two .money").forEach((el) => {
    el.textContent = el.textContent
      .replace(/\$([\d.,]+)\s*USD/i, "$1 €")
      .replace(/USD\s*\$([\d.,]+)/i, "$1 €");
  });

  console.log("💶 Цены переведены в евро (Quick View)");
}

async function fetchProductPricesQuick() {
  try {
    console.log("Запрос цен с сервера...");
    const handleElement = document.getElementById("product-handle");
      if (!handleElement) {
    setTimeout(fetchProductPricesQuick, 500); // Повторяем через 500 мс
    return;
  }
    const productHandle = handleElement.textContent.trim();
    if (!handleElement) return;

    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) throw new Error(" Ошибка загрузки цен");

    const productData = await response.json();

    productData.variants.forEach(variant => {
      originalPricesQuick[variant.id] = variant.price / 100;
    });
  
    console.log(" Цены загружены:", originalPricesQuick);
    return productData;
  } catch (error) {
    console.error(" Ошибка получения цен:", error);
    return null;
  }
}

// Функция расчёта и отображения скидки
function calculateAndDisplayDiscountQuick(priceElement, originalPrice, discountAmount, discountType) {
  if (!originalPrice) {
    console.warn(" Оригинальная цена не найдена, пропускаем элемент:", priceElement);
    return;
  }

  var discountedPrice =
    discountType === "percentage"
      ? Math.round(originalPrice * (1 - discountAmount / 100))
      : Math.round(originalPrice - discountAmount);

  console.log(` Применяем скидку: ${discountType}, Размер: ${discountAmount}, Итоговая цена: ${discountedPrice}`);

    if (isUserFromEUQuick()) {
      priceElement.textContent = `${discountedPrice} €`;
    } else {
      priceElement.textContent = `$${discountedPrice} USD`;
  }
  
}

// Функция обновления цены и скидки
async function updateFirstPriceAndDiscounts() {
  console.log("🔄 Обновление цены и скидок...");

  const productData = await fetchProductPricesQuick();
  
  console.log(productData, "prodcut dattttttt")
  if (!productData) {
    console.warn(" Данные о продукте не получены, прерываем обновление.");
    return;
  }

  const selectedVariantText = document.querySelector(" .form__label__value")?.textContent.trim();
  if (!selectedVariantText) {
    console.warn(" Не найден текст выбранного варианта.");
    return;
  }

  console.log("Выбранный вариант:", selectedVariantText);

  const selectedVariant = productData.variants.find(variant =>
    variant.option1.toLowerCase() === selectedVariantText.toLowerCase()
  );

  if (!selectedVariant) {
    console.warn("Вариант не найден среди доступных вариантов.");
    return;
  }

  console.log(" Найден вариант:", selectedVariant);

  const variantId = selectedVariant.id;
  const originalPrice = originalPricesQuick[variantId];
  if (!originalPrice) {
    console.warn(" Оригинальная цена не найдена для варианта ID:", variantId);
    return;
  }

  console.log(` Оригинальная цена для варианта (${variantId}): $${originalPrice} USD`);

  const firstPriceElement = document.querySelector(".product-information_quick-view #first-price-quick-view");
  console.log(firstPriceElement, "firstPriceElemetn")
let selectors = [
  ".product-information_quick-view #final-price-quick-view .money",
  ".product-information_quick-view #final-price-quick-view-two .money",
  ".product-information_quick-view #final-price-precents-dekstop-quick-view .money",
  ".product-information_quick-view #final-price-precents-dekstop-quick-view-two .money"
];

let finalPriceElement = null;

for (let selector of selectors) {
  finalPriceElement = document.querySelector(selector);
  if (finalPriceElement) break; // Если нашли подходящий элемент, выходим из цикла
}

// Проверяем, найден ли элемент
if (finalPriceElement) {
  console.log("Найден элемент:", finalPriceElement);
} else {
  console.log("Элемент не найден");
}

  const priceContainer = document.querySelector(" .product-information_quick-view .product-price-container"); // Контейнер для цен
  if (!priceContainer) {
    console.error(" Не найден #price-container! Проверь структуру страницы.");
    return;
  }

  // **Обновляем 'first-price'**
  if (firstPriceElement) {
    const moneyElement = firstPriceElement.querySelector(".money");
  
  const currentDisplayedPrice = parseFloat(moneyElement.textContent.trim().replace("$", ""));
  
  if (currentDisplayedPrice !== originalPrice) {
    console.log(`Обновляем 'first-price': $${currentDisplayedPrice} -> $${originalPrice}`);
        if (isUserFromEUQuick()) {
          moneyElement.textContent = `${originalPrice} €`; 
        } else {
          moneyElement.textContent = `$${originalPrice} USD`; 
        }
  } else {
    console.log("'first-price' уже установлен правильно.");
  }
} else {
  console.warn(" Не найден .money внутри #first-price!");
}

  // **Обновляем 'final-price'**
  console.log("Обновляем 'final-price'...");
  if (finalPriceElement) {
    if (isUserFromEUQuick()) {
          finalPriceElement.textContent = `${originalPrice} €`; 
        } else {
          finalPriceElement.textContent = `$${originalPrice} USD`; 
        }
  }

  // **Применяем скидки**
  applyDiscountsQuick(variantId);
}

// Функция применения скидок
function applyDiscountsQuick(variantId) {
  console.log(" Применяем скидки для варианта ID:", variantId);

  const originalPrice = originalPricesQuick[variantId];
  if (!originalPrice) {
    console.warn(" Нет оригинальной цены для варианта, пропускаем скидки.");
    return;
  }

  const discountAmountFromCMC = parseFloat(document.querySelector(" #discount-amount")?.textContent || 0);
  const discountAmountFromCMCSecond = parseFloat(document.querySelector(" #discount-amount-two")?.textContent || 0);
  const discountPercentsFromCMC = parseFloat(document.querySelector(" #discount-percents")?.textContent || 0);
  const discountPercentsFromCMCTwo = parseFloat(document.querySelector(" #discount-percents-two")?.textContent || 0);

  console.log("📉 Скидки загружены:", {
    discountAmountFromCMC,
    discountAmountFromCMCSecond,
    discountPercentsFromCMC,
    discountPercentsFromCMCTwo
  });

  const priceElements = document.querySelectorAll(" #final-price-quick-view .money");
  const priceElementsAmountTwo = document.querySelectorAll(" #final-price-quick-view-two .money");
  const priceElementsPercents = document.querySelectorAll(" #final-price-precents-dekstop-quick-view .money");
  const priceElementsPercentsTwo = document.querySelectorAll(" #final-price-precents-dekstop-quick-view-two .money");

  priceElements.forEach(price => {
    console.log("Применяем основную фиксированную скидку");
    calculateAndDisplayDiscountQuick(price, originalPrice, discountAmountFromCMC, "amount");
  });

  priceElementsAmountTwo.forEach(price => {
    console.log(" Применяем вторую фиксированную скидку");
    calculateAndDisplayDiscountQuick(price, originalPrice, discountAmountFromCMCSecond, "amount");
  });

  priceElementsPercents.forEach(price => {
    console.log("Применяем основную процентную скидку");
    calculateAndDisplayDiscountQuick(price, originalPrice, discountPercentsFromCMC, "percentage");
  });

  priceElementsPercentsTwo.forEach(price => {
    console.log("Применяем вторую процентную скидку");
    calculateAndDisplayDiscountQuick(price, originalPrice, discountPercentsFromCMCTwo, "percentage");
  });
}

// Запускаем код при загрузке страницы
async function executeCodeOnceQuickView() {
  if (codeExecutedQuick) {
    console.log("Код уже был выполнен ранее, пропускаем повторное выполнение.");
    return;
  }
  
  console.log(" Первый запуск кода...");
  await updateFirstPriceAndDiscounts();
  codeExecutedQuick = true;
}

// Отслеживание изменений варианта товара
function observeVariantChangesQuickView() {
  console.log("Начинаем отслеживание изменений варианта...");

  const targetNode = document.querySelector(".form__label__value");
  if (!targetNode) {
    console.warn(" Не найден элемент .form__label__value, отслеживание невозможно.");
    return;
  }

  const config = { childList: true, subtree: true };
  const callback = async function () {
    console.log(" Вариант изменился, пересчитываем цены...");
    await updateFirstPriceAndDiscounts();
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

// // Запускаем код
// document.addEventListener("DOMContentLoaded", () => {
//   executeCodeOnceQuickView();
//   observeVariantChangesQuickView();
// });

document.querySelectorAll(".product-card-quickview").forEach(button => {
  button.addEventListener("click", async () => {
    console.log("Клик по Quick View, загружаем цены...");
      executeCodeOnceQuickView();
    // Сбрасываем флаг, чтобы код мог выполняться заново при каждом открытии Quick View
    codeExecutedQuick = false;

    // ⏳ Добавляем задержку перед загрузкой данных
    await new Promise(resolve => setTimeout(resolve, 1500));

    await fetchProductPricesQuick();
    await updateFirstPriceAndDiscounts();
      (async () => {
  await changeUsdToEuroQuickView();
})();
    observeVariantChangesQuickView();
  });
});

function priceChangeCartDrawerButtons() {
  const allButtonsCartDrawer = document.querySelectorAll(
    ".product-card-small--add-to-cart-button"
  );

  if (allButtonsCartDrawer.length > 0) {
    allButtonsCartDrawer.forEach((button) => {
      button.addEventListener("click", function () {
        setTimeout(function () {
          executeCodeOnceQuickView();
        }, 500);
      });
    });
  } else {
    setTimeout(priceChangeCartDrawerButtons, 500); // Пробуем снова через 500 мс
  }
}

// priceChangeCartDrawerButtons();

var targetNode = document.querySelector("#Product-Drawer-Content");


function fetchValentinesDayCartDataQuick () {
  const url = "https://www.lafloreparis.com/cart.js";

  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      console.log('Valentines Day Cart Data:', data);
      valentinesDayPromoQuickView(data); // Проверяем стоимость корзины
    })
    .catch(error => {
      console.error('Error fetching Valentines Day cart data:', error);
    });
}

const valentinesDayPromoQuickView = ((data) => {
  const totalPriceUSD = data.total_price / 100;

  const giftHandles = ['passport-holder', 'coin-pouch', 'glasses'];
  const hasGift = data.items.some(item => giftHandles.includes(item.handle));

  const cartDrawerWrapper = document.querySelector("#Product-Drawer-Content");

  if (totalPriceUSD > 200 && hasGift === false) {
    console.log("totalPriceUSD > 200 && hasGift === false")
        cartDrawerWrapper.querySelectorAll('.no-free-gift').forEach(element => {
      element.style.display = 'none';
    });

    // Показываем подарки
    cartDrawerWrapper.querySelectorAll('.free-gift').forEach(element => {
      element.style.display = 'block';
    });
  } else {
    console.log("FALSE")
        // Скрываем подарки
    cartDrawerWrapper.querySelectorAll('.free-gift').forEach(element => {
      element.style.display = 'none';
    });

    // Показываем сообщение об отсутствии подарков
    cartDrawerWrapper.querySelectorAll('.no-free-gift').forEach(element => {
      element.style.display = 'block';
    });
    }
})

function updateTextAndExtractQuantity() {
  observerQuickView.disconnect();
  const text = document.getElementById("alert-text");
  const button = document.querySelector(".restock-alerts-float-button");

  const labelValue = document.querySelector(".form__label__value");

  if (!labelValue) {
    // Retry after 200 milliseconds
    setTimeout(updateTextAndExtractQuantity, 200);
    return;
  }

  const itemNameElements = document.querySelectorAll(".name-of-item");
  const selectedProductName = labelValue.textContent.trim();
  let productTitle = document
    .querySelector(".product-title")
    .textContent.trim();

 
 if (labelValue) {
    const availableItemsElement = Array.from(itemNameElements).find(
      (element) => {
        const text = element.textContent.trim();
        return text.startsWith(selectedProductName);
      }
    );
  }

  observerQuickView.observe(targetNode, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("DOMContentLoaded", function () {
  updateTextAndExtractQuantity();
});

const observerQuickView = new MutationObserver(updateTextAndExtractQuantity);

document.addEventListener("DOMContentLoaded", () => {
  // Функция для изменения текста кнопки
  function updateButtonText(buttonId, text, disabled) {
    const button = document.getElementById(buttonId);
    if (button) {
      const spanText = button.querySelector(".single-add-to-cart-button--text");
      if (spanText && spanText.textContent.trim() !== text) {
        spanText.textContent = text;
      }
      button.disabled = disabled;
    }
  }


function updatePriceVariant() {
  const naturalPrice = document.querySelector(
    ".product-information_quick-view .price .amount .money",
  )
  const fakePrice = document.querySelector('.variant-fake-price-meta');
  const originalFakePrice = document.querySelector('.variant-original-price-meta');

  const fakePriceWrapper = document.querySelector(".price-metafields-wrapper");

  const priceData = []
  document.querySelectorAll(".price-metafields-wrapper").forEach((price) => {
    const variantTitle = price
      .querySelector(".variant-meta-title-price")
      ?.textContent.trim()
    const originalPrice = price
      .querySelector(".variant-original-price-meta")
      ?.textContent.trim()
    const fakePrice = price
      .querySelector(".variant-fake-price-meta")
      ?.textContent.trim()
    priceData.push({ variantTitle, originalPrice, fakePrice })
  })

  const selectedVariant = document.querySelector(".form__label__value")

  if (selectedVariant) {
    const variantText = selectedVariant.textContent.trim()
    const variantInfo = priceData.find(
      (variant) =>
        variant.variantTitle.toLowerCase() === variantText.toLowerCase(),
    )

    if (!naturalPrice) {return}

    if (!variantInfo) {
      naturalPrice.style.display = "block"
      if (fakePriceWrapper) {
      fakePriceWrapper.style.display = "none"
      }
    } else {
      naturalPrice.style.display = "none"
      fakePriceWrapper.style.display = "block"
      originalFakePrice.textContent = variantInfo.originalPrice;
      fakePrice.textContent = variantInfo.fakePrice;
    }
  }
}


  // Основная функция для обновления состояния кнопок
  function updateButtons() {
  const inventoryData = [];
  // Считываем данные из скрытого блока inventory-section
  document.querySelectorAll("#inventory-section .name-of-item").forEach((item) => {
    const name = item.querySelector(".variant-name").textContent.trim();
    const inventory = parseInt(item.querySelector(".variant-inventory").textContent.trim(), 10);
    const preorderButton = parseInt(item.querySelector(".variant-pre-order-button").textContent.trim(), 10);
    const preorderButtonText = item.querySelector('.variant-pre-order-button-text')?.textContent.trim();
    inventoryData.push({ name, inventory, preorderButton, preorderButtonText });
  });

  
    const selectedVariant = document.querySelector(".form__label__value");

    if (selectedVariant) {
      const variantText = selectedVariant.textContent.trim();

      // Проверяем, что товар подходит под условия

        // Ищем текущий вариант в данных инвентаря
        const variantInfo = inventoryData.find(
          (variant) => variant.name.toLowerCase() === variantText.toLowerCase()
        );

        if (!variantInfo) {
          return;
        }

        const isOutOfStock = variantInfo.inventory < 1;

        // Логика изменения текста кнопки в зависимости от наличия товара
        if (isOutOfStock) {
          updateButtonText("AddToCart", "SOLD OUT", true);
          updateButtonText("AddToCartSticky", "SOLD OUT", true);
          updateButtonText("AddToCartAddons", "SOLD OUT", true);
        } else if (variantInfo.preorderButton === 1) {
          if (variantInfo.preorderButtonText.length > 1) {
          updateButtonText("AddToCart", variantInfo.preorderButtonText, false);
          updateButtonText("AddToCartSticky", variantInfo.preorderButtonText, false);
          updateButtonText("AddToCartAddons", variantInfo.preorderButtonText, false);  
          } else {
          updateButtonText("AddToCart", "PRE-ORDER NOW", false);
          updateButtonText("AddToCartSticky", "PRE-ORDER NOW", false);
          updateButtonText("AddToCartAddons", "PRE-ORDER NOW", false);  
          }
        } else {
          updateButtonText("AddToCart", "ADD TO CART", false);
          updateButtonText("AddToCartSticky", "ADD TO CART", false);
          updateButtonText("AddToCartAddons", "ADD TO CART", false);
        }
      }
  }

  // Настраиваем MutationObserver для отслеживания изменений
  const targetNode = document.querySelector("#Product-Drawer-Content");
  const observer = new MutationObserver(() => {
    updateButtons();
    updatePriceVariant();
  });

  // Начинаем отслеживать изменения в содержимом карточки продукта
  if (targetNode) {
    observer.observe(targetNode, { childList: true, subtree: true });
  }

  // Выполняем обновление кнопок сразу после загрузки страницы
  updateButtons();

  // Проверяем кнопки каждые 700 мс
  setInterval(() => {
    updateButtons();
  }, 700);
});
 

//fake price logic for the variant
document.querySelectorAll("product-card").forEach(cart => {
    const originalPrices = Array.from(cart.querySelectorAll(".meta-original-price"))
        .map(el => parseFloat(el.textContent.replace(/[^\d.]/g, "")))
        .filter(price => !isNaN(price));

    const fakePrices = Array.from(cart.querySelectorAll(".meta-fake-price"))
        .map(el => parseFloat(el.textContent.replace(/[^\d.]/g, "")))
        .filter(price => !isNaN(price));

    if (fakePrices.length > 0) {
        const minFakePrice = Math.min(...fakePrices); // Находим минимальную цену

        const moneyElement = cart.querySelector(".money");
        const fromElement = cart.querySelector(".from");

        if (moneyElement) {
            moneyElement.textContent = `USD $${minFakePrice}`;
        }
        
        if (fromElement) {
            fromElement.style.display = "inline-flex";
        }
    }
});